import React, { useState, useEffect } from 'react'
import ContentWrapper from '../layouts/contentWrapper'
import Filter from '../../components/Filter';
import Loading from '../../components/Loading';
import ModalMeasurement from '../modals/modal-measurement';
import Grid from '../../components/Grid';
import api from '../../services/api'
import ShowMessages from '../../components/Exceptions'
import setStatistic from '../../services/apiStatistic'
import {checkPermission} from '../../components/security'
import Swal from 'sweetalert2'

export default function Measurement() {
    const [loading, setLoading]                            = useState(false)
    const [showModal, setShowModal]                        = useState(false)

    const [isOpenFilter, setIsOpenFilter]                  = useState(false)
    const [reload, setReload]                              = useState(false)
    const [print, setPrint]                                = useState(false)
    const [excel, setExcel]                                = useState(false)
    const [showButtons, setShowButtons]                    = useState(false)
    const [editState, setEditState]                        = useState(false)
    const [gridParams, setGridParams]                      = useState({})
    const [data, setData]                                  = useState({})
    const [filters, setFilters]                            = useState([])
    const [editPermission, setEditPermisson]               = useState(false)

    const getMeasurement = async() => {
        let _delCheck  = !checkPermission(4,75)
        let _editCheck = !checkPermission(8,75)
        setEditPermisson(_editCheck)
        setGridParams({idmeasurement     : {text       : "#ID", mask : { name  : 'leftSlice',
                                                                        value : '00000'},
                                           primaryKey  : true,
                                           visible : false                          },
                       type             : {text : "Tipo"},
                       costcenter       : {text        : "Obra",
                                           searchDefault : true},
                       customer       : {text        : "Cliente"},
                       measurement_number : {text    : "Nº Medição"},
                       start_date : {text        : "Período Inicial",
                                     dataType : 'date'},
                       end_date   : {text        : "Periodo Final",
                                     dataType : 'date'},
                       measured_value : {text    : "Valor Medido",
                                         className : 'text-right',
                                         dataType : 'money',
                                         item : {
                                           className : 'text-right' 
                                         }},
                       invoiced_amount : {text    : "Valor Faturado",
                                          className : 'text-right',
                                          dataType : 'money',
                                          item : {
                                           className : 'text-right' 
                                          }
                       },
                       status           : {text : "Status"},
                       user_register : {text : 'Usuário Cadastro'},
                       Options          : {text        : "Opções",
                                           className   : "text-center",
                                           order       : false,
                                           filter      : false,
                                           item        : [{type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Exclusão da medição",
                                                                    className      : 'btn btn-sm btn-danger',
                                                                    icon           : "fa fa-trash",
                                                                    disabled       : _delCheck,
                                                                    indexcallback  : 0}},
                                                          {type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Editar medição",
                                                                    disabled       : _editCheck,
                                                                    className      : 'btn btn-sm btn-warning',
                                                                    icon           : "fa fa-edit",
                                                                    indexcallback  : 1}},
                                                          {type  : "Custom",
                                                           props : {tag            : "button",
                                                                    title          : "Alterar Status",
                                                                    disabled       : _editCheck,
                                                                    visualConditional : {status : {operator : '!=',
                                                                                                   values   : ['Finalizado']}},
                                                                    className      : 'btn btn-sm btn-primary',
                                                                    icon           : "fa fa-check",
                                                                    indexcallback  : 2}}]}

                 })
    }

    useEffect(() => {
        getMeasurement()
        setStatistic('maintenance\\measurement')
    },[])

    const handleCloseModal = () => {setShowModal(false)}
    const handleFilter     = () => {setIsOpenFilter(!isOpenFilter)}

    const RemoveMeasurement = async (id) => {
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente excluir a medição?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async(result) => {
            if (result.isConfirmed) {
                await api.delete('/measurement/' + id)
                         .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                         })
                         .catch( error => {
                            ShowMessages(error)
                         })
            }

        })
    }

    const EditMeasurement = async(id) => {
        await api.get('/measurement/' + id)
                 .then(response => {
                    setData(response.data)
                    setEditState(true)
                    setShowModal(true)
                 })
                 .catch( error => {
                    ShowMessages(error)
                 })
    }

    const handleStatus = async (id, a, b,_data) => {
        Swal.fire({
            title: 'Escolha uma opção:',
            html: `
    <button id="btn1" class="swal2-confirm4 swal2-styled" style="background-color:#dc3545;color:#fff; border-radius:5px">Finalizar</button>` + 
    (_data.status !== 'Andamento' ? '<button id="btn2" class="swal2-cancel swal2-styled" style="background-color:#0d6efd;">Em Andamento</button>' : '') + 
    `<button id="btn3" class="swal2-deny swal2-styled" style="background-color:#dc3545;">Sair</button>`,
            showConfirmButton: false, // desativa botões padrão
            didOpen: () => {
                document.getElementById('btn1').addEventListener('click', async () => {
                    Swal.close();
                    await api.post('/measurement/status/' + id, {
                        status: 'Finalizado'
                    })
                        .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                        })
                        .catch(error => {
                            ShowMessages(error)
                        })
                });
                document.getElementById('btn2') && document.getElementById('btn2').addEventListener('click', async () => {
                    Swal.close();
                    await api.post('/measurement/status/' + id, {
                        status: 'Andamento'
                    })
                        .then(response => {
                            ShowMessages(response.data)
                            setReload(true)
                        })
                        .catch(error => {
                            ShowMessages(error)
                        })
                });
                document.getElementById('btn3').addEventListener('click', () => {
                    Swal.close();
                });
            }
        })
    }

    return (
        <ContentWrapper>
            <Loading loading={loading}/>
            {showModal && <ModalMeasurement showModal={showModal} handleCloseModal = {handleCloseModal} editState={editState} data={data} handleReload={setReload}/>}
            <div className={`container-lg container-100 ${(loading ? "hidden" : "")}`}>
                <div className="content-heading">
                    <div className="box-maintance-buttons">
                        <div>
                            <button className="btn btn-success" disabled={!checkPermission(2,75)} title="Insere um novo registro" onClick={e => {setEditState(false)
                                                                                                               setShowModal(true)}}><i className="fa fa-plus"></i></button>
                            <button className="btn btn-primary" title="Atualizar Dados" style={{marginLeft:"3px"}} onClick={e => setReload(true)}><i className="fa fa-redo"></i></button>
                            {showButtons ?
                                <>
                                    <button className="btn btn-dark" title="Impressão" onClick={e => setPrint(true)} style={{marginLeft:"3px"}}><i className="fa fa-print"></i></button>
                                    <button className="btn btn-info" disabled={!checkPermission(16,75)} title="Exportar para excel" onClick={e => setExcel(true)} style={{marginLeft:"3px"}}><i className="fa fa-file-excel">    </i></button>
                                    <button className="btn btn-secondary" title="Filtros Avançados" style={{marginLeft:"3px"}} onClick={e => handleFilter()}><i className="fa fa-search-plus"></i></button>
                                </>
                            : "" }
                        </div>
                    </div>
                </div>
            </div>
            <div className={`content-box-cart ${(loading ? "hidden" : "")}`}>
                <Filter isOpenFilter={isOpenFilter} filters={gridParams} callback={setFilters} callBackOpenFilter={handleFilter}/>
                <Grid url                 = '/measurement'
                      headers             = {gridParams}
                      loading             = {setLoading}
                      reload              = {reload}
                      print               = {print}
                      excel               = {excel}
                      filters             = {filters}
                      filename            = "Medição"
                      callbackShowButtons = {setShowButtons}
                      callbackExcel       = {setExcel}
                      callbackPrint       = {setPrint}
                      callbackReload      = {setReload}
                      callbackCellClick   = {editPermission ? undefined : EditMeasurement}
                      callbackButtons     = {[RemoveMeasurement,
                                              EditMeasurement,
                                              handleStatus]}
                      />
            </div>
        </ContentWrapper>
    )
}